<template>
  <footer>
    <div class="logo-box">
      <img src="../assets/images/footer/logo.svg" class="logo" alt="">
      <p class="copyright-info">
        <span>©2017 Hypergryph Co., Ltd</span>
        <span> ©2018 Yostar, Inc.</span>
      </p>
    </div>
    <div class="item-box">
      <a target="_blank" class="item-box-a" href="https://www.arknights.jp/privacy_policy">プライバシーポリシー</a>
      <a target="_blank" class="item-box-a" href="https://www.arknights.jp/terms_of_service">ユーザー規約</a>
      <a target="_blank" class="item-box-a" href="https://www.arknights.jp/contact-1-hint">お問い合わせ</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",

  components: {},
  data: () => ({}),
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
footer {
  width: 100%;
  padding: pxTorem(13px) pxTorem(20px);
  box-sizing: border-box;
  border-top: 1px solid #333333;
  display: flex;
  justify-content: space-between;
  .logo-box {
    width: pxTorem(428px);

    .logo {
      display: block;
      width: 100%;
    }
    .copyright-info {
      box-sizing: border-box;
      padding:  0 pxTorem(10px);
      color: #fff;
      display: flex;
      justify-content: space-between;
      font-size: pxTorem(12px);
    }
  }
  .item-box {
    .item-box-a {
      font-size: pxTorem(18px);
      color: #878787;
      padding: 0 pxTorem(6px);
      border-right: 1px solid #000;
      &:hover {
        color: #ffee22;
      }
    }
    .item-box-a:last-of-type{
         border-right: none;
    } 
    .information {
      font-size: pxTorem(18px);
      color: #878787;
    }
  }
}
</style>
